//Lenis START
let lenis;

function lenisStart() {
	lenis = new Lenis({
		duration: 2,
		smooth: true,
		smoothTouch: true,
	});

	gsap.ticker.add((time) => {
		lenis.raf(time * 1000);
	});
	gsap.ticker.lagSmoothing(0);

	const refresh = () => {
		ScrollTrigger.clearScrollMemory();
		window.history.scrollRestoration = 'manual';
		ScrollTrigger.refresh(true);
	};
	refresh();
	window.addEventListener('resize', refresh);
}
//Lenis END

// Smooth scroll START
$(function() {
	$('a[href*="#"]:not([href="#"])').on('click', function (e) {
		const pathnameMatch =
			location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '');
		const hostnameMatch = location.hostname === this.hostname;

		if (pathnameMatch && hostnameMatch) {
			const target = $(this.hash);
			if (target.length) {
				e.preventDefault();

				let headerTop = $('header[role=banner]').position().top;
 				let headerHeight = $('header[role=banner]').innerHeight();
				let offsetS = headerTop + headerHeight;

				if (typeof lenis !== 'undefined') {
					// Use Lenis’s scrollTo method for smooth scrolling
					lenis.scrollTo(target[0], {
						offset: -offsetS,
						duration: .2,
						easing: (t) => t, // optional linear easing
					});
				} else {
					// Fallback in case Lenis isn't ready
					$('html, body').animate({
						scrollTop: target.offset().top - offsetS,
					}, 200);
				}
			}
		}
	});
});
// Smooth scroll END

//Waypoints START
function waypoints() {
	$('.waypoint').each(function() {
		var thisOne = $(this);

		var waypoint = new Waypoint({
			element: thisOne,
			handler: function(direction) {
				if(direction == 'down'){
					
					if(thisOne.parents('section').is(':first-child')){
						thisOne.addClass('animate');
					}else{
						setTimeout(function(){
							thisOne.addClass('animate');
						}, 200);
					}
				}
			},
			offset: '90%',
		});

		var waypoint = new Waypoint({
			element: thisOne,
			handler: function(direction) {
				if(direction == 'up'){
					//thisOne.removeClass('animate');
				}
			},
			offset: '100%'
		});
	});
}
//Waypoints END

//Waypoint.refreshAll();

//Scroll Menu START
var body = document.body;
var triggerMenu = document.querySelector(".page-header .trigger-menu");
var nav = document.querySelector(".page-header nav");
var menu = document.querySelector(".page-header .menu");
var scrollUp = "scroll-up";
var scrollDown = "scroll-down";
let lastScroll = 0;

function handleScroll() {
	var currentScroll = window.pageYOffset;
	if (currentScroll < 50) {
		body.classList.remove(scrollUp);
		body.classList.remove(scrollDown);
		return;
	}

	if (currentScroll > lastScroll && !body.classList.contains(scrollDown)) {
		// down
		body.classList.remove(scrollUp);
		body.classList.add(scrollDown);
	} else if (currentScroll < lastScroll && currentScroll < 50 && body.classList.contains(scrollDown)) {
		// up and at top
		body.classList.remove(scrollDown);
		body.classList.remove(scrollUp);
	} else if (currentScroll < lastScroll && body.classList.contains(scrollDown)) {
		// up
		body.classList.remove(scrollDown);
		body.classList.add(scrollUp);
	}
	lastScroll = currentScroll;
}

window.addEventListener("scroll", handleScroll);

// Run once on load
document.addEventListener("DOMContentLoaded", handleScroll);
window.addEventListener("load", handleScroll);
//Scroll Menu END

//THIS PASSES THE THEME URL TO THE JS VIA FUNCTIONS.PHP
//console.log(myTheme);

//ACCORDION START
function accordion() {
	if ($('dl.accordion').length > 0) {
		
		$(document).on('click', 'dl.accordion dt', function(){
			var thisOne = $(this);
			thisOne.parent('dl.accordion').find('dt').next('dd').css('maxHeight', '0px');
			thisOne.parent('dl.accordion').find('dt').removeClass('open').find('i').find('span').text('open table');
			var ddH = thisOne.next('dd').find('.inner').outerHeight();
			thisOne.next('dd').css('maxHeight', ddH+'px');
			thisOne.addClass('open').find('i').find('span').text('close table');
	
			setTimeout(function(){
				Waypoint.refreshAll();
			}, 500);
		});
	
		$(document).on('click', 'dl.accordion dt.open', function(){
			var thisOne = $(this);
			thisOne.parent('dl.accordion').find('dt').removeClass('open').find('i').find('span').text('open table');
			thisOne.parent('dl.accordion').find('dt').next('dd').css('maxHeight', '0px');
			thisOne.removeClass('open').find('i').find('span').text('open table');
			
			setTimeout(function(){
				Waypoint.refreshAll();
			}, 500);
		});
	
		$(window).resize(function() {
			$('dl.accordion dt.open').each(function(){
				var thisOne = $(this);
				var ddH = thisOne.next('dd').find('.inner').outerHeight();
				thisOne.next('dd').css('maxHeight', ddH+'px');
			});
		});
	}
}
//ACCORDION END



//SEE IF A LINK OPENS A POPUP START
function popUp() {
	//checks to see if a links starts with #pop-
	$('a[href^="#pop-"], button[href^="#pop-"]').on('click', function(e){
		e.preventDefault();
		var thisOne = $(this);
		var thisPop = thisOne.attr('href');

		$('html').addClass('pop-open');
		$('.popup-con').removeClass('open');
		$('.popup-con'+thisPop).addClass('open');

		$('html').removeClass('menu-open');
		$('.burger').addClass('close').removeClass('open');
	});

	//closes all popups
	$('.popup-con .close').on('click', function(e){
		$('html').removeClass('pop-open');
		$('.popup-con').removeClass('open');
	});

	$('.pop-inner').click(function(e){
		e.stopPropagation()
	});
}
//SEE IF A LINK OPENS A POPUP END

//BURGER AND MENU START
function burgerAndMenu() {
	$('.burger').click(function(){
		$('.burger').toggleClass('open').addClass('close');
		$('html').toggleClass('menu-open').removeClass('pop-open');
		$('.popup-con ').removeClass('open');
		//$(this).text($(this).hasClass('open') ? 'Close' : 'Menu');
	});

	$('li.menu-item-has-children').click(function(){
		$(this).toggleClass('open');
	});

	$('.main-menu li a').click(function(e){
		e.stopPropagation();
		$('.burger').removeClass('open').addClass('close');
		$('html').toggleClass('menu-open').removeClass('pop-open');
		$('.popup-con ').removeClass('open');
	});

	$('.main-menu li li').click(function(e){
		e.stopPropagation()
	});
}
//BURGER AND MENU END

//WP IMAGE CON FIX START
function wpImageFix() {
	$('p:has(img)').css('margin-bottom','0').addClass('p-img');

	// $('img.alignnone, img.alignright, img.alignleft, img.aligncenter ').each(function(){
	// 	var thisOne = $(this);
	// 	var thiswidth = thisOne.attr('width');

	// 	thisOne.css('width', thiswidth/10 + 'rem')
	// });
}
//WP IMAGE CON FIX END

//TABS START
function tabs() {
	$(document).on('click', '.tabs .tab, .tab-head', function() {
		var thisOne = $(this);
		thisOne.parents('.tab-container').find('.tab-content, .tabs .tab, .tab-head').removeClass('active');
		var activeTab = $(this).attr("rel");
		
		thisOne.parents('.tab-container').find('#'+activeTab).addClass('active');
		$(this).addClass('active');
		thisOne.parents('.tab-container').find('.tabs .tab[rel^='+activeTab+']').addClass('active');
		thisOne.parents('.tab-container').find('.tab-head[rel^='+activeTab+']').addClass('active');

		setTimeout(function(){
			Waypoint.refreshAll();
		}, 500);
	});
}
//TABS END

//SIMPLED VIDEO PLAYER START
function simpleVideo() {
	$('.video-con .play-video').on('click', function(){
		var thisOne = $(this);
		var video = thisOne.parent('.video-con').addClass('playing').find('video')
		video.get(0).play()
	});

	$('.video-con .unmute').on('click', function() {
		var btn = $(this);
		var container = btn.parent('.video-con');
		var video = container.find('video').get(0);
		var label = btn.find('span');

		// toggle mute
		video.muted = !video.muted;

		// update UI
		if (video.muted) {
			container.removeClass('unmute');
			label.text('Audio On');
		} else {
			container.addClass('unmute');
			label.text('Audio Off');
			video.play();
		}
	});
}
//SIMPLED VIDEO PLAYER END

//PAGE TRANSITION START
function pageTransition() {
	let transitionTime = 200; //ms - may need to add more of a delay if the transition animation is more complex

	if (typeof wpRocket !== 'undefined' && wpRocket.is_on) {
		console.log('WP Rocket is on');
		transitionTime = 200; // ms - may need to add more of a delay if the transition animation is more complex
	}
	
	$('.loading-block').css('transition-duration', transitionTime+'ms');

	$('a:not([target="_blank"]):not([href^="#pop-"]):not([data-fancybox])').each(function () {
		const $link = $(this);
		let href = $link.attr('href');

		// Skip empty/hash/javascript links
		if (!href || href.startsWith('#') || href.startsWith('javascript:')) return;

		if (href && href.startsWith('/#')) {
			href = href.replace(/^\/+/, "");
			if (href.length > 0) return;
		}

		// Prefetch
		$link.on('mouseenter focus', function () {
			if (!$(`link[rel="prefetch"][href="${href}"]`).length) {
				$('<link rel="prefetch" href="' + href + '" />').appendTo('head');
			}
		});

		// Transition
		$link.on('click', function (e) {
			if (e.metaKey || e.ctrlKey || e.which === 2) return;

			e.preventDefault();
			$('html').addClass('internal-loaded');

			setTimeout(function () {
				window.location = href;
			}, transitionTime);
		});
	});

	window.addEventListener('pageshow', function () {
		document.documentElement.classList.remove('internal-loaded');
		if (typeof waypoints === 'function') waypoints();
	});

	$('html').removeClass('internal-loaded');
}
//PAGE TRANSITION END

//SIMPLED NEXT START
function nextLink() {
	$('.next-link').on('click', function(e){
		e.preventDefault();

		var thisOne = $(this);
		const target = thisOne.parents('section').next('section');
		
		let headerTop = $('header[role=banner]').position().top;
		let headerHeight = $('header[role=banner]').innerHeight();
		let offsetS = headerTop + headerHeight;

		if (typeof lenis !== 'undefined') {
			// Use Lenis’s scrollTo method for smooth scrolling
			lenis.scrollTo(target[0], {
				offset: -offsetS,
				duration: .2,
				easing: (t) => t, // optional linear easing
			});
		} else {
			// Fallback in case Lenis isn't ready
			$('html, body').animate({
				scrollTop: target.offset().top - offsetS,
			}, 200);
		}
	});
}
//SIMPLED NEXT END

//SIMPLED NEXT START
$(function () {

	function initTeamBios() {

		$('.t-item').each(function () {

			const $item = $(this);
			const $image = $item.find('.image-reveal');
			const $bio = $item.find('.bio-over');
			const $button = $item.find('.read-more');

			// Reset everything
			$bio.removeAttr('style');

			$button
				.css('display', 'none')
				.removeClass('open')
				.find('span')
				.text('Read More');

			const imageHeight = $image.outerHeight();
			const bioHeight = $bio.outerHeight();

			// Only clamp if bio is more than 102% taller than the image
			if (bioHeight > imageHeight * 1.02) {

				let lineHeight = parseFloat($bio.css('line-height'));

				// Fallback if line-height is "normal"
				if (isNaN(lineHeight)) {
					lineHeight = parseFloat($bio.css('font-size')) * 1.5;
				}

				// Show one extra full line
				const lines = Math.floor(imageHeight / lineHeight) + 1;
				const clampHeight = lines * lineHeight;

				$bio
					.data('collapsed-height', clampHeight)
					.css({
						maxHeight: clampHeight + 'px',
						overflow: 'hidden'
					});

				$button.css('display', 'inline-flex');
			}

		});

	}

	initTeamBios();

	let resizeTimer;

	$(window).on('resize', function () {

		clearTimeout(resizeTimer);

		resizeTimer = setTimeout(function () {
			initTeamBios();
		}, 200);

	});

	$(document).on('click', '.read-more', function () {

		const $button = $(this);
		const $bio = $button.closest('.bio-side').find('.bio-over');

		const collapsedHeight = $bio.data('collapsed-height');
		const fullHeight = $bio.get(0).scrollHeight;

		if ($button.hasClass('open')) {

			// Collapse
			$bio.stop().animate({
				maxHeight: collapsedHeight
			}, 400);

			$button
				.removeClass('open')
				.find('span')
				.text('Read More');

			setTimeout(function(){
				Waypoint.refreshAll();
			}, 500);

		} else {

			// Expand
			$bio.stop().animate({
				maxHeight: fullHeight
			}, 400);

			$button
				.addClass('open')
				.find('span')
				.text('Read Less');

			setTimeout(function(){
				Waypoint.refreshAll();
			}, 500);
		}

	});

});
//SIMPLED NEXT END

document.addEventListener('DOMContentLoaded', () => {
	const header = document.querySelector('header[role="banner"]');
	const target = document.querySelector('.text-with-image-footer-section');

	if (!header || !target) return;

	function updateHeaderDarken() {
		const headerHeight = header.offsetHeight;
		const rect = target.getBoundingClientRect();

		const overlapping =
			rect.top <= headerHeight &&
			rect.bottom > 0;

		document.body.classList.toggle('header-darken', overlapping);
	}

	window.addEventListener('scroll', updateHeaderDarken, { passive: true });
	window.addEventListener('resize', updateHeaderDarken);

	updateHeaderDarken();
});

$(window).ready(function() {
	pageTransition();
	wpImageFix();
	accordion();
	burgerAndMenu();
	//popUp();
	//tabs();
	simpleVideo();
	nextLink();

	$('.simple-text-section table').wrap('<div class="table-con"></div>')
});

$(window).on('load', function(){
	$('html').addClass('loaded');

	$('.facetwp-type-pager').addClass('waypoint');

	//gsap.registerPlugin(ScrollTrigger);

	lenisStart();

	setTimeout(function(){
		$(window).trigger('resize');

		setTimeout(function(){
			$(window).trigger('resize');
			waypoints();
		}, 0);
	}, 0);
	
	// const swiper = new Swiper('.-slide', {
	// 	loop: true,
	// 	spaceBetween: 0,
	// 	slidesPerView: 1,
	// 	preventInteractionOnTransition: true,
	// 	centerInsufficientSlides: true,
	// 	centeredSlides: false,
	// 	autoplay: {
	// 		delay: 3000,
	// 		disableOnInteraction: false,
	// 		pauseOnMouseEnter: true,
	// 	},
	// 	speed: 300,
	// 	navigation: {
	// 		nextEl: '.swiper-button-next',
	// 		prevEl: '.swiper-button-prev',
	// 	},
	// 	pagination: {
	// 		el: '.swiper-pagination',
	// 		type: 'bullets',
	// 		clickable: true,
	// 	},
	// 	scrollbar: {
	// 		el: '.swiper-scrollbar',
	// 		draggable: true,
	// 		hide: false,
	// 	},
	// 	breakpoints: {
	// 		992: {
	// 			centeredSlides: false,
	// 			spaceBetween: 0,
	// 			slidesPerView: 3,
	// 		},
	// 		1441: {
	// 			spaceBetween: 0,
	// 			slidesPerView: 4,
	// 		}
	// 	}
	// });

	const swiperLo = new Swiper('.hero-slide', {
		loop: true,
		spaceBetween: 0,
		slidesPerView: 1,
		preventInteractionOnTransition: true,
		centerInsufficientSlides: true,
		centeredSlides: false,
		autoplay: {
			delay: 3000,
			disableOnInteraction: false,
			pauseOnMouseEnter: true,
		},
		speed: 300,
		effect: 'fade',
		fadeEffect: {
			crossFade: true
		},
	});

	const swiperP = new Swiper('.project-slide', {
		loop: false,
		spaceBetween: 0,
		slidesPerView: 1,
		preventInteractionOnTransition: true,
		centerInsufficientSlides: true,
		centeredSlides: false,
		// autoplay: {
		// 	delay: 3000,
		// 	disableOnInteraction: false,
		// 	pauseOnMouseEnter: true,
		// },
		speed: 300,
		breakpoints: {
			992: {
				centeredSlides: false,
				spaceBetween: 0,
				slidesPerView: 3,
			}
		},
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		pagination: {
			el: '.swiper-pagination',
			type: 'fraction',
			clickable: true,
			renderFraction: function (currentClass, totalClass) {
				return '<span class="' + currentClass + '"></span>' + '–' + '<span class="' + totalClass + '"></span>';
			},
		},
	});

	const swiperT = new Swiper('.testimonials-slide', {
		loop: true,
		spaceBetween: 0,
		slidesPerView: 1,
		preventInteractionOnTransition: true,
		centerInsufficientSlides: true,
		centeredSlides: false,
		// autoplay: {
		// 	delay: 3000,
		// 	disableOnInteraction: false,
		// 	pauseOnMouseEnter: true,
		// },
		speed: 300,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
	});

	

	// child and parent slides
	// swiperQ.controller.control = swiperQI;
	// swiperQI.controller.control = swiperQ;

	$('.swiper-wrapper').each(function(){
		$(this).parents('.swiper').css('overflow', 'visible');
		$(this).wrap('<div class="swiper-wrapper-con" style="overflow: hidden;"></div>');
	});

	$('.gform_button.button').append('<i><svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 4C6.89373 4 5.89571 4.44884 5.17228 5.17228C4.44884 5.89571 4 6.89373 4 8C4 6.89373 3.55116 5.89571 2.82772 5.17228C2.10429 4.44884 1.10627 4 0 4C1.10627 4 2.10429 3.55116 2.82772 2.82772C3.55116 2.10429 4 1.10627 4 0C4 2.2099 5.7901 4 8 4Z" fill="#F2F0EC"/></svg></i>');

	jQuery(document).on('gform_page_loaded', function(event, form_id, current_page){
		$('.gform_button.button').append('<i><svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 4C6.89373 4 5.89571 4.44884 5.17228 5.17228C4.44884 5.89571 4 6.89373 4 8C4 6.89373 3.55116 5.89571 2.82772 5.17228C2.10429 4.44884 1.10627 4 0 4C1.10627 4 2.10429 3.55116 2.82772 2.82772C3.55116 2.10429 4 1.10627 4 0C4 2.2099 5.7901 4 8 4Z" fill="#F2F0EC"/></svg></i>');
	});

	$(document).on("gform_confirmation_loaded", function (e, form_id) {
		Waypoint.refreshAll();
		
		setTimeout(function(){
			$(window).trigger('resize');
			waypoints();
			//ScrollTrigger.refresh();
		}, 0);
	});

	$('.i-item .text-con').matchHeight({ property: 'min-height' });

	$('.t-item .text-con').matchHeight({ property: 'min-height' });

	$('.c-item .text-con').matchHeight({ property: 'min-height' });

	document.addEventListener('facetwp-loaded', function(event){
		const url = new URL(window.location.href);
		const searchInput = document.querySelector('.facetwp-facet-s input.facetwp-search');

		if ( searchInput && searchInput.value === '' ) {
			// Ensure the URL always has _s= even if empty
			if (!url.searchParams.has('_s')) {
				url.searchParams.set('_s', '');
				window.history.replaceState({}, '', url.toString());
			}
		}

		setTimeout(function(){
			$(window).trigger('resize');
			waypoints();
			//ScrollTrigger.refresh();

			$('.i-item .text-con').matchHeight({ property: 'min-height' });
			$('.t-item .text-con').matchHeight({ property: 'min-height' });
		}, 0);
	});	

	$('.lp-course-description').fitVids();

	Fancybox.bind("[data-fancybox]", {
		Hash: false,
	});

	// //google map
	// (function( $ ) {

	// 	/**
	// 	 * initMap
	// 	 *
	// 	 * Renders a Google Map onto the selected jQuery element
	// 	 *
	// 	 * @date    22/10/19
	// 	 * @since   5.8.6
	// 	 *
	// 	 * @param   jQuery $el The jQuery element.
	// 	 * @return  object The map instance.
	// 	 */
	// 	function initMap( $el ) {
	
	// 		var stylers = [
	// 			{
	// 				"featureType": "all",
	// 				"elementType": "labels.text.fill",
	// 				"stylers": [
	// 					{
	// 						"saturation": 36
	// 					},
	// 					{
	// 						"color": "#000000"
	// 					},
	// 					{
	// 						"lightness": 40
	// 					}
	// 				]
	// 			},
	// 			{
	// 				"featureType": "all",
	// 				"elementType": "labels.text.stroke",
	// 				"stylers": [
	// 					{
	// 						"visibility": "on"
	// 					},
	// 					{
	// 						"color": "#000000"
	// 					},
	// 					{
	// 						"lightness": 16
	// 					}
	// 				]
	// 			},
	// 			{
	// 				"featureType": "all",
	// 				"elementType": "labels.icon",
	// 				"stylers": [
	// 					{
	// 						"visibility": "off"
	// 					}
	// 				]
	// 			},
	// 			{
	// 				"featureType": "administrative",
	// 				"elementType": "geometry.fill",
	// 				"stylers": [
	// 					{
	// 						"color": "#000000"
	// 					},
	// 					{
	// 						"lightness": 20
	// 					}
	// 				]
	// 			},
	// 			{
	// 				"featureType": "administrative",
	// 				"elementType": "geometry.stroke",
	// 				"stylers": [
	// 					{
	// 						"color": "#000000"
	// 					},
	// 					{
	// 						"lightness": 17
	// 					},
	// 					{
	// 						"weight": 1.2
	// 					}
	// 				]
	// 			},
	// 			{
	// 				"featureType": "administrative",
	// 				"elementType": "labels",
	// 				"stylers": [
	// 					{
	// 						"visibility": "off"
	// 					}
	// 				]
	// 			},
	// 			{
	// 				"featureType": "administrative.country",
	// 				"elementType": "all",
	// 				"stylers": [
	// 					{
	// 						"visibility": "simplified"
	// 					}
	// 				]
	// 			},
	// 			{
	// 				"featureType": "administrative.country",
	// 				"elementType": "geometry",
	// 				"stylers": [
	// 					{
	// 						"visibility": "simplified"
	// 					}
	// 				]
	// 			},
	// 			{
	// 				"featureType": "administrative.country",
	// 				"elementType": "labels.text",
	// 				"stylers": [
	// 					{
	// 						"visibility": "simplified"
	// 					}
	// 				]
	// 			},
	// 			{
	// 				"featureType": "administrative.province",
	// 				"elementType": "all",
	// 				"stylers": [
	// 					{
	// 						"visibility": "off"
	// 					}
	// 				]
	// 			},
	// 			{
	// 				"featureType": "administrative.locality",
	// 				"elementType": "all",
	// 				"stylers": [
	// 					{
	// 						"visibility": "simplified"
	// 					},
	// 					{
	// 						"saturation": "-100"
	// 					},
	// 					{
	// 						"lightness": "30"
	// 					}
	// 				]
	// 			},
	// 			{
	// 				"featureType": "administrative.neighborhood",
	// 				"elementType": "all",
	// 				"stylers": [
	// 					{
	// 						"visibility": "off"
	// 					}
	// 				]
	// 			},
	// 			{
	// 				"featureType": "administrative.land_parcel",
	// 				"elementType": "all",
	// 				"stylers": [
	// 					{
	// 						"visibility": "off"
	// 					}
	// 				]
	// 			},
	// 			{
	// 				"featureType": "landscape",
	// 				"elementType": "all",
	// 				"stylers": [
	// 					{
	// 						"visibility": "simplified"
	// 					},
	// 					{
	// 						"gamma": "0.00"
	// 					},
	// 					{
	// 						"lightness": "74"
	// 					}
	// 				]
	// 			},
	// 			{
	// 				"featureType": "landscape",
	// 				"elementType": "geometry",
	// 				"stylers": [
	// 					{
	// 						"color": "#000000"
	// 					},
	// 					{
	// 						"lightness": 20
	// 					}
	// 				]
	// 			},
	// 			{
	// 				"featureType": "landscape.man_made",
	// 				"elementType": "all",
	// 				"stylers": [
	// 					{
	// 						"lightness": "3"
	// 					}
	// 				]
	// 			},
	// 			{
	// 				"featureType": "poi",
	// 				"elementType": "all",
	// 				"stylers": [
	// 					{
	// 						"visibility": "off"
	// 					}
	// 				]
	// 			},
	// 			{
	// 				"featureType": "poi",
	// 				"elementType": "geometry",
	// 				"stylers": [
	// 					{
	// 						"color": "#000000"
	// 					},
	// 					{
	// 						"lightness": 21
	// 					}
	// 				]
	// 			},
	// 			{
	// 				"featureType": "road",
	// 				"elementType": "geometry",
	// 				"stylers": [
	// 					{
	// 						"visibility": "simplified"
	// 					}
	// 				]
	// 			},
	// 			{
	// 				"featureType": "road.highway",
	// 				"elementType": "geometry.fill",
	// 				"stylers": [
	// 					{
	// 						"color": "#000000"
	// 					},
	// 					{
	// 						"lightness": 17
	// 					}
	// 				]
	// 			},
	// 			{
	// 				"featureType": "road.highway",
	// 				"elementType": "geometry.stroke",
	// 				"stylers": [
	// 					{
	// 						"color": "#000000"
	// 					},
	// 					{
	// 						"lightness": 29
	// 					},
	// 					{
	// 						"weight": 0.2
	// 					}
	// 				]
	// 			},
	// 			{
	// 				"featureType": "road.arterial",
	// 				"elementType": "geometry",
	// 				"stylers": [
	// 					{
	// 						"color": "#000000"
	// 					},
	// 					{
	// 						"lightness": 18
	// 					}
	// 				]
	// 			},
	// 			{
	// 				"featureType": "road.local",
	// 				"elementType": "geometry",
	// 				"stylers": [
	// 					{
	// 						"color": "#000000"
	// 					},
	// 					{
	// 						"lightness": 16
	// 					}
	// 				]
	// 			},
	// 			{
	// 				"featureType": "transit",
	// 				"elementType": "geometry",
	// 				"stylers": [
	// 					{
	// 						"color": "#000000"
	// 					},
	// 					{
	// 						"lightness": 19
	// 					}
	// 				]
	// 			},
	// 			{
	// 				"featureType": "water",
	// 				"elementType": "geometry",
	// 				"stylers": [
	// 					{
	// 						"color": "#000000"
	// 					},
	// 					{
	// 						"lightness": 17
	// 					}
	// 				]
	// 			}
	// 		]
	
	// 		// Find marker elements within map.
	// 		var $markers = $el.find('.marker');
	
	// 		// Create gerenic map.
	// 		var mapArgs = {
	// 			//styles		: stylers,
	// 			mapTypeControl: false,
	// 			//draggable: false,
	// 			scaleControl: false,
	// 			scrollwheel: false,
	// 			fullscreenControl: false,
	// 			navigationControl: false,
	// 			streetViewControl: false,
	// 			zoom        : $el.data('zoom') || 16,
	// 			mapTypeId   : google.maps.MapTypeId.ROADMAP
	// 		};
	// 		var map = new google.maps.Map( $el[0], mapArgs );
	
	// 		// Add markers.
	// 		map.markers = [];
	// 		$markers.each(function(){
	// 			initMarker( $(this), map );
	// 		});
	
	// 		// Center map based on markers.
	// 		centerMap( map );
	
	// 		// Return map instance.
	// 		return map;
	// 	}
	
	// 	/**
	// 	 * initMarker
	// 	 *
	// 	 * Creates a marker for the given jQuery element and map.
	// 	 *
	// 	 * @date    22/10/19
	// 	 * @since   5.8.6
	// 	 *
	// 	 * @param   jQuery $el The jQuery element.
	// 	 * @param   object The map instance.
	// 	 * @return  object The marker instance.
	// 	 */
	// 	function initMarker( $marker, map ) {
	
	// 		// Get position from marker.
	// 		var lat = $marker.data('lat');
	// 		var lng = $marker.data('lng');
	// 		var latLng = {
	// 			lat: parseFloat( lat ),
	// 			lng: parseFloat( lng )
	// 		};
	
	// 		const icon = {
	// 			url: myTheme.theme_directory+"/assets/images/marker.svg", // url
	// 			scaledSize: new google.maps.Size(82, 103), // scaled size
	// 			origin: new google.maps.Point(0,0), // origin
	// 			anchor: new google.maps.Point(41, 103) // anchor
	// 		};
	
	// 		// Create marker instance.
	// 		var marker = new google.maps.Marker({
	// 			position : latLng,
	// 			//icon: icon,
	// 			map: map
	// 		});
	
	// 		// Append to reference for later use.
	// 		map.markers.push( marker );
	
	// 		// If marker contains HTML, add it to an infoWindow.
	// 		if( $marker.html() ){
	
	// 			// Create info window.
	// 			var infowindow = new google.maps.InfoWindow({
	// 				content: $marker.html()
	// 			});
	
	// 			// Show info window when marker is clicked.
	// 			google.maps.event.addListener(marker, 'click', function() {
	// 				infowindow.open( map, marker );
	// 			});
	// 		}
	// 	}
	
	// 	/**
	// 	 * centerMap
	// 	 *
	// 	 * Centers the map showing all markers in view.
	// 	 *
	// 	 * @date    22/10/19
	// 	 * @since   5.8.6
	// 	 *
	// 	 * @param   object The map instance.
	// 	 * @return  void
	// 	 */
	// 	function centerMap( map ) {
	
	// 		// Create map boundaries from all map markers.
	// 		var bounds = new google.maps.LatLngBounds();
	// 		map.markers.forEach(function( marker ){
	// 			bounds.extend({
	// 				lat: marker.position.lat(),
	// 				lng: marker.position.lng()
	// 			});
	// 		});
	
	// 		// Case: Single marker.
	// 		if( map.markers.length == 1 ){
	// 			map.setCenter( bounds.getCenter() );
	
	// 		// Case: Multiple markers.
	// 		} else{
	// 			map.fitBounds( bounds );
	// 		}
	// 	}
	
	// 	$('.acf-map').each(function(){
	// 		var map = initMap( $(this) );
	// 	});
	
	// })(jQuery);

});